import { Container, Grid } from "@mui/material";
import React from "react";
import { SectionHeading, SectionWrapper } from "../../../styles";
import styled from "@emotion/styled"; 

const SectionSmallHeading = styled.h4`
  padding-top: 0;
  margin-top: ${(props) => (props.mt ? props.mt : "0px")};
  margin-bottom: ${(props) => (props.mb ? props.mb : "40px")};
  font-size: ${(props) => (props.fs ? props.fs : "45px")};
  font-family: "twocent-bold-italic";
  color: #ffffff;
  letter-spacing: 4px;
  @media (max-width: 899px) {
    font-size: 40px;
  }
  @media (max-width: 599px) {
    font-size: 35px;
  }
`;
const LogoImages = styled(Grid)`
  opacity: 0.5;
  @media screen and (max-width: 900px) {
    text-align-last: center;
  }
`;
const CollabImage = styled.img`
  width: 100%;
  height: auto;
  max-width: 258px;
`;
const index = () => {
  return (
    <div style={{ backgroundColor: "#FF0029" }}>
      <SectionWrapper
        bgColor="#000"
        id="collabs"
        // data-aos="fade-zoom-in"
        // data-aos-easing="ease-in"
        // data-aos-delay="500"
        // data-aos-offset="0"
      >
        <Container maxWidth="xl">
          <SectionHeading>Collabs</SectionHeading>
          <SectionSmallHeading>Projects</SectionSmallHeading>
          <LogoImages container spacing={9}>
            <Grid item xs={12} sm={6} md={3}>
              <CollabImage
                src="/images/collabslogo1.png" 
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CollabImage
                src="/images/collabslogo2.png" 
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CollabImage
                src="/images/collabslogo3.png" 
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CollabImage
                src="/images/collabslogo4.png" 
              />
            </Grid>
          </LogoImages>

          <SectionSmallHeading mt="60px">Wallet Supported</SectionSmallHeading>
          <LogoImages container spacing={9}>
            <Grid item xs={12} sm={6} md={3}>
              <CollabImage
                src="/images/collabslogo1.png" 
              />
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <CollabImage
                src="/images/collabslogo2.png" 
              />
            </Grid>
          </LogoImages>
        </Container>
      </SectionWrapper>
    </div>
  );
};

export default index;
